// extracted by mini-css-extract-plugin
export default {"tickerShell":"Ticker_tickerShell__do+tb","tickerText":"Ticker_tickerText__adST2"};